import { config, type Config } from "../config";
import {
  dashboardFetchUserURL,
  toShellUser as dashboardToShellUser,
  getDashboardUser,
} from "./dashboard/getUser";
import {
  engageFetchUserURL,
  toShellUser as engageToShellUser,
  getEngageUser,
} from "./engage/getUser";
import {
  MMFetchPartnerURL,
  toShellPartner as mmToShellPartner,
} from "./mm/getPartner";
import {
  getMmUser,
  MMFetchUserURL,
  toShellUser as mmToShellUser,
} from "./mm/getUser";
import type { ApiStrategy } from "./types";

const notAvailable = () => {
  console.error("Can't fetch this on the current platform");
  return {};
};

const apiStrategies: Record<Config["API_STRATEGY"], ApiStrategy> = {
  engage: {
    urls: {
      userUrl: engageFetchUserURL,
      partnerUrl: "",
    },
    formatters: {
      toShellUser: engageToShellUser,
      toShellPartner: notAvailable,
    },
    getUser: getEngageUser,
  },
  mm: {
    urls: {
      userUrl: MMFetchUserURL,
      partnerUrl: MMFetchPartnerURL,
    },
    formatters: {
      toShellUser: mmToShellUser,
      toShellPartner: mmToShellPartner,
    },
    getUser: getMmUser,
  },
  cop: {
    urls: {
      userUrl: "",
      partnerUrl: "",
    },
    formatters: {
      // TODO: add function for formatting COP user here
      toShellUser: engageToShellUser,
      toShellPartner: notAvailable,
    },
    // TODO: add function for getting COP user here
    getUser: getEngageUser,
  },
  dashboard: {
    urls: {
      userUrl: dashboardFetchUserURL,
      partnerUrl: "",
    },
    formatters: {
      toShellUser: dashboardToShellUser,
      toShellPartner: notAvailable,
    },
    getUser: getDashboardUser,
  },
};

export const apiUrls = apiStrategies[config.API_STRATEGY].urls;
export const formatters = apiStrategies[config.API_STRATEGY].formatters;

export const getUser = apiStrategies[config.API_STRATEGY].getUser;
